<template>
  <div class="flex justify-center items-center min-h-screen">
    <p>กำลังเข้าสู่ระบบผ่าน LINE...</p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LineCallback',
  async mounted() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code) {
      console.error("❌ ไม่พบ code จาก LINE");
      this.$router.push('/login'); // หรือ route fallback
      return;
    }

    try {
      const response = await axios.get(`/api/v3.0/auth/line/callback?code=${code}&state=${state}`);

      if (response.data.success && response.data.redirectTo) {
        window.location.href = response.data.redirectTo;
      } else {
        console.error("❌ ไม่สามารถ redirect ได้:", response.data);
        this.$router.push('/login');
      }
    } catch (err) {
      console.error("❌ Error เรียก backend:", err);
      this.$router.push('/login');
    }
  }
}
</script>
